import { useContext } from "react";
import { Link, matchPath, useLocation } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";

import CounterItem from "./counterItem/counterItem";

import { FiltersContext } from "../../../services/context/filters";
import { W3Context } from "../../../services/context";

import { formattedWallet } from "../../../utils/account";
import PATHS from "../../../utils/paths";

import nftIcon from "../../../assets/nft_icon_white.png";
import tokenIcon from "../../../assets/token_icon_white.png";
import wheelIcon from "../../../assets/wheel_icon_white.png";

import "./counterItemsStyles.css";

const CounterItems = ({
  geoTokensAmount,
  NFTsAmount,
  geoSpinsAmount,
  setDisplayBuyGEOTokens,
  onClickConnectWallet,
}) => {
  const location = useLocation();
  const { pathname } = location;
  let match;
  // https://stackoverflow.com/a/59217492
  // eslint-disable-next-line no-unused-vars
  for (let [_, value] of Object.entries(PATHS)) {
    match = matchPath(pathname, {
      path: value,
      exact: true,
      strict: false,
    });

    if (match) {
      break;
    }
  }

  const { setFilters } = useContext(FiltersContext);
  const { active, account } = useContext(W3Context);

  const onClickNavigationButton = () => {
    setFilters({});
  };

  return (
    <Container className="counter-items-container pr-0">
      <Row className="counter-items-row">
        <Col xs={12} lg="auto" className="px-1">
          <button
            onClick={() => setDisplayBuyGEOTokens(true)}
            className="d-flex align-items-center header-button geos-button justify-content-center w-100"
          >
            <span>Buy GEO$</span>
          </button>
        </Col>
        {match &&
          match.path !== PATHS.AUCTIONS_ID &&
          match.path !== PATHS.AUCTIONS && (
            <Col xs={12} lg="auto" className="px-1">
              <Link
                to={{
                  pathname: PATHS.AUCTIONS,
                }}
              >
                <button
                  className="d-flex align-items-center header-button market-button justify-content-center w-100"
                  onClick={onClickNavigationButton}
                  disabled={!active}
                >
                  <span>CURRENT AUCTIONS</span>
                </button>
              </Link>
            </Col>
          )}
        {match &&
          match.path !== PATHS.AUCTIONS_ID &&
          match.path !== PATHS.AUCTIONS_MYAUCTIONS && (
            <Col xs={12} lg="auto" className="px-1 d-lg-none">
              <Link
                to={{
                  pathname: PATHS.AUCTIONS_MYAUCTIONS,
                }}
              >
                <button
                  className="d-flex align-items-center header-button market-button justify-content-center w-100"
                  onClick={onClickNavigationButton}
                  disabled={!active}
                >
                  <span>START NEW AUCTION</span>
                </button>
              </Link>
            </Col>
          )}
        {match &&
          match.path !== PATHS.AUCTIONS_ID &&
          match.path !== PATHS.AUCTIONS_MYAUCTIONS && (
            <Col xs={12} lg="auto" className="px-1">
              <Link
                to={{
                  pathname: PATHS.AUCTIONS_MYAUCTIONS,
                }}
              >
                <button
                  className="d-flex align-items-center header-button market-button justify-content-center w-100"
                  onClick={onClickNavigationButton}
                  disabled={!active}
                >
                  <span>MY AUCTIONS</span>
                </button>
              </Link>
            </Col>
          )}
        {match &&
          match.path !== PATHS.AUCTIONS_ID &&
          match.path !== PATHS.AUCTIONS_MYBIDS && (
            <Col xs={12} lg="auto" className="px-1">
              <Link
                to={{
                  pathname: PATHS.AUCTIONS_MYBIDS,
                }}
              >
                <button
                  className="d-flex align-items-center header-button market-button justify-content-center w-100"
                  onClick={onClickNavigationButton}
                  disabled={!active}
                >
                  <span>MY BIDS</span>
                </button>
              </Link>
            </Col>
          )}
        <Col xs={12} lg="auto" className="px-1">
          {active ? (
            <span className="d-flex align-items-center header-text wallet-button justify-content-center">
              {formattedWallet(account)}
            </span>
          ) : (
            <button
              onClick={() => onClickConnectWallet()}
              className="d-flex align-items-center header-button market-button justify-content-center w-100"
            >
              <span>Connect Wallet</span>
            </button>
          )}
        </Col>
        <Col xs={4} lg="auto" className="px-1">
          <CounterItem
            icon={tokenIcon}
            iconAlt="geo-token-icon"
            amount={geoTokensAmount}
            {...(active && {
              onClick: () => window.open("https://geopoly.io/staking"),
            })}
          />
        </Col>
        <Col xs={4} lg="auto" className="px-1">
          <CounterItem
            icon={nftIcon}
            iconAlt="nft-icon"
            amount={NFTsAmount}
            {...(active && {
              onClick: () => window.open("https://geopoly.io/nft-farming"),
            })}
          />
        </Col>
        <Col xs={4} lg="auto" className="px-1">
          <CounterItem
            icon={wheelIcon}
            iconAlt="wheel-icon"
            amount={geoSpinsAmount}
            {...(active && {
              onClick: () => window.open("https://geopoly.io/wheel-of-fortune"),
            })}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default CounterItems;
